module.exports = __webpack_public_path__ + "friend1.png?7f4e5b37a36b98cd851e33ac4c1fb78f";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend1.png
// module id = 474
// module chunks = 0